<!--content orders-->
<div class="container pt-5 px-lg-0">
	<div class="my-5">
		<div class="text-center mb-2">
			<h1 class="titolo-bertazzoni">MY ORDERS</h1>
			<p class="didascalia-bertazzoni">
				To view order details click on plus icon on the right in order head (black banner) and if you want to send an order by email, to
				generate a pdf file or to export an order in Excel click on related icons over the round icon
			</p>
		</div>
		<div class="mx-auto col-12 col-md-10 mt-5">
			<div class="d-lg-flex">
				<div class="d-flex justify-content-between">
					<h6 class="mr-4 mb-0">Order date:</h6>
					<div class="form-group mb-0 w-100">
						<select class="minimal w-100 rounded-0 border-black" name="anno" [(ngModel)]="filtri.anno" (change)="aggiornaOrdini()">
							<option *ngFor="let anno of anni" [value]="anno">{{anno}}</option>
						</select>
					</div>
				</div>
				<div class="ml-lg-5 mt-3 mt-lg-0 d-none">
					<h6 class="mb-0 mr-3">Open orders:</h6>
					<div class="custom-control custom-checkbox">
						<input class="checkbox" type="checkbox" id="check-open" value="" name="filtroDaConfermare" [(ngModel)]="filtri.daConfermare" />
					</div>
				</div>
				<div class="ml-lg-5 mt-3 mt-lg-0 d-flex">
					<div class="row no-gutters">
						<div class="col">
							<input
								class="form-bertazzoni white border-right-0 rounded-0"
								type="SEARCH"
								placeholder="SEARCH"
								id=""
								name="parola"
								[(ngModel)]="filtri.parola" />
						</div>
						<div class="col-auto">
							<div class="border-left-0 rounded-0 rounded-right form-bertazzoni-search" (click)="filtra()">
								<i class="icon-search font-16"></i>
							</div>
						</div>
					</div>
				</div>
			</div>

			<div class="border border-black mt-4" *ngFor="let ordine of ordiniVisualizzati">
				<div class="bg-black text-white font-12 p-3 accordion-header">
					<div class="row">
						<div class="col-10">
							<div class="row">
								<div class="col-md-5">
									<p class="font-14">
										<span class="font-semibold">Order Number ERP Number:</span>
										{{trovaNSimag(ordine)}}
									</p>
								</div>
								<div class="col-md-3">
									<p class="font-14">
										<span class="font-semibold">Order Number:</span>
										{{ordine.id}}
									</p>
								</div>
								<div class="col-md-3">
									<p class="font-14">
										<span class="font-semibold">Order Date:</span>
										{{ordine.dataRegistrazioneOrdine | date}}
									</p>
								</div>
							</div>
							<div class="row">
								<div class="col-md-5">
									<p class="font-14">
										<span class="font-semibold">Purchase Order:</span>
										{{ordine.rifOrdineCliente}}
									</p>
								</div>
								<div class="col-md-3">
									<p class="font-14">
										<span class="font-semibold">Total:</span>
										{{ '' | valuta }} {{totaleOrdine(ordine) | currency:'':''}}
									</p>
								</div>
								<div class="col-md-3">
									<p class="font-14">
										<span class="font-semibold">Articles total:</span>
										{{ordine.quantita}}
									</p>
								</div>
							</div>
							<div class="row">
								<div class="col-md-12">
									<p class="font-14">
										<span class="font-semibold">Shipping address:</span>
										<span *ngIf="ordine.indirizzo">
											{{ordine.indirizzo.indirizzo}}, {{ordine.indirizzo.localita}} {{ordine.indirizzo.provincia}}, {{ordine.indirizzo.cap}}
										</span>
										<span *ngIf="!ordine.indirizzo">
											{{ordine.utente.cliente.indirizzo}}, {{ordine.utente.cliente.localita}} {{ordine.utente.cliente.provincia}},
											{{ordine.utente.cliente.cap}}
										</span>
									</p>
								</div>
							</div>
							<div class="row" *ngIf="ordine.company.connettore === 'AS400'">
								<div class="col-md-3">
									<p class="font-14 pointer" (click)="apriModalePriorita(ordine, contentPriorita)">
										<span class="font-semibold"><u>Set the order priority</u></span>
									</p>
								</div>
								<div class="col-md-4">
									<p class="font-14">
										<span class="font-semibold">{{getMessaggioPrioritario(ordine)}}</span>
									</p>
								</div>
							</div>
						</div>
						<div class="col-2">
							<div class="d-flex mb-3">
								<button class="btn btn-block rounded-0 py-1 mt-0" (click)="openMail(contentMail, ordine.id)">
									<img src="assets/img/envelop.svg" class="tracking action-icon" loading="lazy" />
								</button>
								<button class="btn btn-block rounded-0 py-1 mt-0" (click)="getPdfOrdine(ordine.id)">
									<img src="assets/img/file-pdf.svg" class="tracking action-icon" loading="lazy" />
								</button>
								<button class="btn btn-block rounded-0 py-1 mt-0" (click)="getExcelOrdine(ordine.id)">
									<img src="assets/img/file-excel.svg" class="tracking action-icon" loading="lazy" />
								</button>
							</div>

							<button class="btn btn-block rounded-0 py-1 mt-0" (click)="ordine.feOpen = !ordine.feOpen" style="color: white;">
								<img [src]="ordine.feOpen ? 'assets/img/minus.svg' :  'assets/img/plus.svg'" class="action-icon mb-1 mr-2" loading="lazy" />
								Details
							</button>

							<div class="d-flex mt-4" *ngIf="ordine.confermato && showContainerizzazione">
								<button
									type="button"
									class="btn btn-bertazzoni black rounded-0 px-2 border border-white mx-auto"
									(click)="toContainer(ordine)">
									CONTAINER
								</button>
							</div>
						</div>
					</div>
				</div>
				<div class="p-3 corpo-accordion" *ngIf="ordine.feOpen">
					<div class="row align-items-center mb-4" *ngFor="let item of ordine.prodottiCarrello">
						<div class="col-lg-3 col-5">
							<img [src]="item.prodottoCommerciale.immagini[0]?.path | img" loading="lazy" />
						</div>
						<div class="col-lg-9 col-7">
							<p class="font-18 font-semibold mb-2">{{getDescrizione(item.prodottoCommerciale)?.valore}}</p>
							<p class="mb-2">{{item.prodottoCommerciale.prodotto.lineaEstetica | translate | titlecase}} Series</p>
							<p class="text-secondary font-12 mb-2">
								{{item.prodottoCommerciale.codiceCommerciale}}
								<span class="font-semibold text-black font-14 ml-3" *ngIf="item.prioritario">(Prioritized)</span>
							</p>
							<p class="font-12 mb-2">
								<span class="font-semibold">Quantity:</span>
								{{item.quantita}}
							</p>
							<p class="mb-2">{{ '' | valuta }} {{getPrezzo(item, ordine) | number}}</p>
						</div>
					</div>
					<div class="row mt-2">
						<div class="col-2 text-left align-self-center">
							<p class="font-14 pl-3 mt-2">
								<span class="font-semibold mr-2">Articles Total:</span>
								{{ordine.quantita}}
							</p>
						</div>
						<div class="col-6 text-center">
							<p class="font-14 mt-2">
								<span class="font-semibold mr-2" *ngIf="!ordine.isEdit">Requested Departure Date:</span>
								<span *ngIf="!ordine.isEdit">{{ordine.dataConsegnaRichiesta | date}}</span>
							</p>
						</div>
						<div class="col-3">
							<a class="font-12 mt-2" (click)="ordine.isEdit = !ordine.isEdit" *ngIf="!ordine.isEdit && !ordine.confermato">
								<u><span class="font-semibold ml-3">Do you want to modify the order?</span></u>
							</a>
						</div>
					</div>
					<form #formOrdine="ngForm">
						<div class="row mt-3" *ngIf="ordine.isEdit">
							<div class="col-12" *soloUsa>
								<p>
									To modify quantities or products in your order, please send an email to
									<a class="text-underline" href="mailto:sales.us@bertazzoni.com">sales.us&#64;bertazzoni.com</a>
									.
								</p>
							</div>
							<div class="col-12">
								<span class="font-14 mt-2 font-semibold mr-2">Shipping address:</span>
								<select
									class="w-100 rounded-0 border-black minimal mt-2"
									name="indMobile"
									[(ngModel)]="ordine.jsonIn.codiceIndirizzoSpedizioneAS400"
									required>
									<option [ngValue]="null">Select address</option>
									<option *ngFor="let indirizzo of indirizzi" [value]="indirizzo.codiceCliente">
										{{indirizzo.indirizzo}}, {{indirizzo.localita}} {{indirizzo.provincia}}, {{indirizzo.cap}}
									</option>
								</select>
							</div>
						</div>
						<div class="row mt-3" *ngIf="ordine.isEdit">
							<div class="col-4">
								<span class="font-14 font-semibold mr-2 mt-2">Customer order reference:</span>
								<br />
								<input
									type="text"
									maxlength="20"
									class="form-control mb-2 rounded-0 form-bertazzoni white mt-2 w-100"
									placeholder="CUSTOMER ORDER REFERENCE"
									name="rifOrdineCliente"
									[(ngModel)]="ordine.jsonIn.rifOrdineCliente" />
							</div>
							<div class="col-4">
								<span class="font-14 mt-2 font-semibold mr-2">Requested Departure Date:</span>
								<br />
								<input
									type="date"
									class=" d-inline form-control mb-2 rounded-0 form-bertazzoni white w-100 mt-2"
									name="dataConsegnaRichiesta"
									[(ngModel)]="ordine.jsonIn.dataConsegnaRichiesta"
									required />
							</div>
							<div class="col-4 text-right">
								<span class="font-14 mt-2 font-semibold mr-2">&nbsp;</span>
								<br />
								<button type="button" class="btn btn-bertazzoni white rounded-0 px-4 py-2 ml-3 mt-2" (click)="ordine.isEdit = false">
									CANCEL
								</button>
								<button
									type="button"
									class="btn btn-bertazzoni black rounded-0 px-4 py-2 ml-3 mt-2"
									[disabled]="formOrdine.invalid"
									(click)="modificaOrdine(ordine)">
									SAVE
								</button>
							</div>
						</div>
					</form>
				</div>
			</div>
		</div>
	</div>
</div>

<ng-template #contentPriorita let-modal>
	<div class="modal-header">
		<h5 class="modal-title" id="">Set order priority</h5>
		<button type="button" class="close" aria-label="Close" (click)="modal.close()">
			<span aria-hidden="true">&times;</span>
		</button>
	</div>
	<div class="modal-body">
		<form #formMail="ngForm">
			<div class="row">
				<div class="col-12">
					<label class="font-16 font-semibold mr-3" for="prioritario">Prioritize the whole order</label>
					<input
						class="checkbox float-right mr-3"
						type="checkbox"
						id="prioritario"
						value=""
						name="prioritario"
						[(ngModel)]="ordineSelected.prioritario" />
				</div>
				<div class="col-12" *ngIf="!ordineSelected.prioritario">
					<div class="row" *ngFor="let item of ordineSelected.prodottiCarrello">
						<div class="col-12"><hr class="my-2" /></div>
						<div class="col-12">
							<label for="prioritario-{{item.id}}">{{item.prodottoCommerciale.codiceCommerciale}}</label>
							<input
								class="checkbox float-right mr-3"
								type="checkbox"
								id="prioritario-{{item.id}}"
								value=""
								name="prioritario-{{item.id}}"
								[(ngModel)]="item.prioritario" />
						</div>
					</div>
				</div>
				<div class="col-12 mt-2 d-flex mt-3">
					<button class="btn btn-bertazzoni white btn-block rounded-0 mt-0 w-25 ml-auto" (click)="modal.close()">CLOSE</button>
					<button
						class="btn btn-bertazzoni black btn-block rounded-0 mt-0 w-25 ml-3"
						[class.disabled]="formMail.invalid"
						[disabled]="formMail.invalid"
						(click)="savePriorita(modal)">
						SAVE
					</button>
				</div>
			</div>
		</form>
	</div>
</ng-template>

<ng-template #mailSuccess let-modalmailsuccess>
	<div class="modal-header">
		<h5 class="modal-title" id="">E-Mail Sent !</h5>
		<button type="button" class="close" aria-label="Close" (click)="modalmailsuccess.close()">
			<span aria-hidden="true">&times;</span>
		</button>
	</div>
</ng-template>

<ng-template #contentMail let-modal>
	<div class="modal-header">
		<h5 class="modal-title" id="">Send an E-Mail</h5>
		<button type="button" class="close" aria-label="Close" (click)="modal.close()">
			<span aria-hidden="true">&times;</span>
		</button>
	</div>
	<div class="modal-body">
		<form #formMail="ngForm">
			<div class="row">
				<div class="col-12">
					<label class="font-14">Sender</label>
					<input
						type="text"
						class="form-control mb-2 rounded-0 form-bertazzoni white disabled"
						placeholder="SENDER*"
						name="sender"
						[(ngModel)]="jsonInMail.sender"
						required
						disabled />
				</div>
				<div class="col-12">
					<label class="font-14">Recipients* ( separated by semicolon ';' )</label>
					<input
						type="text"
						class="form-control mb-2 rounded-0 form-bertazzoni white"
						placeholder="RECIPIENTS* ( separated by semicolon ';' )"
						name="recipients"
						[(ngModel)]="jsonInMail.recipients"
						required />
				</div>
				<div class="col-12 mt-3">
					<input
						type="text"
						class="form-control mb-2 rounded-0 form-bertazzoni white"
						placeholder="SUBJECT*"
						name="subject"
						[(ngModel)]="jsonInMail.subject"
						required />
				</div>
				<div class="col-12 mt-1">
					<textarea
						type="text"
						class="form-control mb-2 rounded-0 form-bertazzoni white"
						style="height: auto;"
						placeholder="BODY"
						rows="10"
						name="body"
						[(ngModel)]="jsonInMail.body"></textarea>
				</div>
				<div class="col-12" *ngIf="mailError">
					<p class="ont-16 mb-0 mt-1 text-danger">{{mailError | translate}}</p>
				</div>
				<div class="col-12 mt-2 d-flex">
					<p class="ont-16 mb-0 mt-1">Attachments:</p>
					<button
						class="btn btn-bertazzoni black btn-block rounded-0 mt-0 ml-3"
						style="width: 15% !important;"
						(click)="getPdfOrdine(idOrdineMail)">
						PDF
					</button>
					<button class="btn btn-bertazzoni black btn-block rounded-0 mt-0 w-25 ml-auto" (click)="modal.close()">CLOSE</button>
					<button
						class="btn btn-bertazzoni black btn-block rounded-0 mt-0 w-25 ml-3"
						[class.disabled]="formMail.invalid"
						[disabled]="formMail.invalid"
						(click)="sendMail(modal, mailSuccess)">
						SEND
					</button>
				</div>
			</div>
		</form>
	</div>
</ng-template>
